import { IUseGraphqlWatchQueryOptions } from '@proscom/prostore-apollo-react';
import { skipIfNull } from '@proscom/prostore';
import { ProjectType } from '../../types';
import { useAuthGraphqlQuery } from '../../../common/hooks/utils/useAuthGraphqlQuery';
import { QUERY_GET_PROJECT } from '../../queries/projects';

const queryOptions: IUseGraphqlWatchQueryOptions<
  { id: string } | null,
  ProjectType | null
> = {
  query: QUERY_GET_PROJECT,
  skipQuery: skipIfNull(null),
  mapData: (result) => result.project
};

export function useProject(id?: string) {
  return useAuthGraphqlQuery({
    queryOptions,
    variables: id
      ? {
          id
        }
      : null
  });
}
